import {
  MANAGE_ACTION,
  SNAPSHOT_APPROVER,
  READ_ACTION,
  CREATE_ACTION,
  DASHBOARD_BANNER,
  ANNOUNCEMENT_RESOURCE,
  WHATS_NEW_RESOURCE,
  PROFILE,
  BUSINESS_UNIT,
} from "@/constants/resources";

export default [
  {
    path: "/comunicados",
    name: "announcements-list",
    component: () => import("@/modules/system/views/AnnouncementList.vue"),
    meta: {
      resource: ANNOUNCEMENT_RESOURCE,
      action: READ_ACTION,
      pageTitle: "Comunicados",
    },
  },
  {
    path: "/comunicados/:id?",
    name: "announcement-save",
    component: () => import("@/modules/system/views/AnnouncementSave.vue"),
    meta: {
      resource: ANNOUNCEMENT_RESOURCE,
      action: CREATE_ACTION,
      pageTitle: "Novo comunicado",
    },
  },
  {
    path: "/o-que-ha-de-novo",
    name: "whats-new-list",
    component: () => import("@/modules/whats-new/views/WhatsNewList.vue"),
    meta: {
      resource: WHATS_NEW_RESOURCE,
      action: READ_ACTION,
      pageTitle: "O que há de novo",
    },
  },
  {
    path: "/o-que-ha-de-novo/:id?",
    name: "whats-new-save",
    component: () => import("@/modules/whats-new/views/WhatsNewSave.vue"),
    meta: {
      resource: WHATS_NEW_RESOURCE,
      action: CREATE_ACTION,
      pageTitle: "Novo comunicado",
    },
  },
  {
    path: "/banners",
    name: "dashboard-banners",
    component: () => import("@/modules/system/views/DashboardBannerList.vue"),
    meta: {
      resource: DASHBOARD_BANNER,
      action: CREATE_ACTION,
      pageTitle: "Banners",
    },
  },
  {
    path: "/unidades-de-negocio",
    name: "business-units-list",
    component: () => import("@/modules/system/views/BusinessUnitList.vue"),
    meta: {
      resource: BUSINESS_UNIT,
      action: READ_ACTION,
      pageTitle: "Unidades de negócio",
    },
  },
  {
    path: "/permissoes/perfil/:id?",
    name: "access-profile",
    component: () =>
      import("@/modules/access_management/views/NewAccessProfile.vue"),
    meta: {
      resource: PROFILE,
      action: CREATE_ACTION,
      pageTitle: "Novo perfil de acesso",
    },
  },
  {
    path: "/permissoes/usuarios/:id",
    name: "access-profile-users",
    component: () =>
      import("@/modules/access_management/views/AcessProfileUsersList.vue"),
    meta: {
      resource: PROFILE,
      action: CREATE_ACTION,
      pageTitle: "Gerenciamento de usuários",
    },
  },
  {
    path: "/permissoes/perfis",
    name: "access-profiles-list",
    component: () =>
      import("@/modules/access_management/views/ProfileList.vue"),
    meta: {
      resource: PROFILE,
      action: CREATE_ACTION,
      pageTitle: "Perfis de acesso",
    },
  },
  {
    path: "/configuracoes/aprovadores-de-snapshot",
    name: "snapshot-approvers-list",
    component: () =>
      import("@/modules/snapshot_change/views/SnapshotApproversList.vue"),
    meta: {
      resource: SNAPSHOT_APPROVER,
      action: MANAGE_ACTION,
      pageTitle: "Aprovadores de snapshot",
    },
  },
];
